module.exports = __webpack_public_path__ + "img/github.ea3740aa.svg";